import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import images from '../../../../../../constants/imageSources/imageSources';
import handleKeyPress from '../../../../../../common/handleKeyPress';

export default class ColumnItemControls extends PureComponent {
    state = {
        overTransformIcon: null,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!nextProps.shouldRender) {
            return {
                ...prevState,
                overTransformIcon: null,
                addNewElementAtBottomButton: false,
                addNewElementAtTopButton: false,
            };
        }
        return { ...prevState };
    }

    render() {
        const { shouldRender, duplicateColumnItem, deleteColumnItem } = this.props;

        if (!shouldRender) {
            return null;
        }

        const copyOrDeleteElement = () => {
            // eslint-disable-next-line react/destructuring-assignment
            const action = this.state.overTransformIcon;
            if (action !== null) {
                switch (action) {
                    case 'copy':
                        duplicateColumnItem();
                        return;
                    case 'delete':
                        deleteColumnItem();
                        break;
                    default:
                }
            }
        };

        return (
            <Styled.ColumnControlWrapper
                onClick={copyOrDeleteElement}
                onKeyDown={(e) => handleKeyPress(e, copyOrDeleteElement)}
            >
                <Styled.IconSpanLeft
                    onMouseOver={() => this.setState({ overTransformIcon: 'copy' })}
                    onFocus={() => this.setState({ overTransformIcon: 'copy' })}
                    tabIndex="0"
                    role="button"
                    aria-label="copy element"
                    onKeyDown={(e) => handleKeyPress(e, copyOrDeleteElement)}
                >
                    <img src={images.ICONS.COPY} style={{ width: 16, cursor: 'pointer' }} alt="Copy Element" />
                </Styled.IconSpanLeft>
                <div
                    style={{
                        width: 1,
                        height: 20,
                        backgroundColor: '#EDEDED',
                        margin: '4px 0',
                    }}
                />
                <Styled.IconSpanRight
                    onMouseOver={() => this.setState({ overTransformIcon: 'delete' })}
                    onFocus={() => this.setState({ overTransformIcon: 'delete' })}
                    tabIndex="0"
                    role="button"
                    aria-label="delete element"
                    onKeyDown={(e) => handleKeyPress(e, copyOrDeleteElement)}
                >
                    <Styled.Icon className="material-icons" delete>
                        delete
                    </Styled.Icon>
                </Styled.IconSpanRight>
            </Styled.ColumnControlWrapper>
        );
    }
}

ColumnItemControls.propTypes = {
    shouldRender: PropTypes.bool.isRequired,
    duplicateColumnItem: PropTypes.func.isRequired,
    deleteColumnItem: PropTypes.func.isRequired,
};
